import { JobPostingTab } from '../JobPostingTab/JobPostingTab';
import { JobViewTabData } from './types';
import { QuestionsTab } from '../QuestionsTab/QuestionsTab';
import { SetUpTab } from '../SetUpTab/SetUpTab';
import HiringTeamTab from '../HiringTeamTab';
import InternalNotesTab from '../InternalNotesTab';
import VacanciesTab from '../VacanciesTab/VacanciesTab';
import { ActivityFeedTab } from '../ActivityFeedTab/ActivityFeedTab';
import { AutomationsTab } from '../AutomationsTab/AutomationsTab';

export const getTopTabsData = (
  jobId: number,
  isDistrictAdmin: boolean,
  inPostingOnlyDistrict: boolean
): JobViewTabData[] => [
  {
    value: 0,
    label: 'Job Posting',
    content: <JobPostingTab jobId={jobId} />,
    isVisible: true,
    route: `/internal/jobview/${jobId}/details`,
  },
  {
    value: 1,
    label: 'Questions',
    content: <QuestionsTab jobId={jobId} />,
    isVisible: !inPostingOnlyDistrict,
    route: `/internal/jobview/${jobId}/questions`,
  },
  {
    value: 2,
    label: 'Vacancies',
    content: <VacanciesTab jobId={jobId} />,
    isVisible: isDistrictAdmin,
    route: `/internal/jobview/${jobId}/vacancies`,
  },
  {
    value: 3,
    label: 'Job Set-up',
    content: <SetUpTab jobId={jobId} />,
    isVisible: !inPostingOnlyDistrict,
    route: `/internal/jobview/${jobId}/setup`,
  },
  {
    value: 4,
    label: 'Hiring Team',
    content: <HiringTeamTab jobId={jobId} />,
    isVisible: isDistrictAdmin && !inPostingOnlyDistrict,
    route: `/internal/jobview/${jobId}/hiring-team`,
  },
];

export const getBottomTabsData = (
  jobId: number,
  isDistrictAdmin: boolean,
  inPostingOnlyDistrict: boolean,
  isAtsLiteDistrict: boolean
): JobViewTabData[] => [
  {
    value: 5,
    label: 'Candidates',
    isVisible: isDistrictAdmin && !inPostingOnlyDistrict,
    route: `/district/requisition-view/${jobId}`,
  },
  {
    value: 6,
    label: 'Internal Notes',
    content: <InternalNotesTab jobId={jobId} />,
    isVisible: true,
    route: `/internal/jobview/${jobId}/internal-notes`,
  },
  {
    value: 7,
    label: 'Automations',
    content: <AutomationsTab jobId={jobId} />,
    isVisible: isDistrictAdmin && !inPostingOnlyDistrict && !isAtsLiteDistrict,
    route: `/internal/jobview/${jobId}/automations`,
  },
  {
    value: 8,
    label: 'Activity Feed',
    content: <ActivityFeedTab jobId={jobId} />,
    isVisible: isDistrictAdmin,
    route: `/internal/jobview/${jobId}/activity-feed`,
  },
];
